<template>
  <section>
    <v-switch v-model="enabledSwitch" label=" Enable" color="success" @change="setEnabled()" />
    <v-snackbar v-model="snackbarShow" :color="snackbarColor" :timeout="2500">
      <v-card-text class="text-xs-center">{{snackbarMessage}}</v-card-text>
    </v-snackbar>
  </section>
</template>

<script>
import axios from "axios";
import qs from "qs";

axios.defaults.withCredentials = true;

export default {
  name: "enabled_message_switch",
  props: {
    messageKey: String,
    enabled: Boolean,
    currentType: String
  },
  data: function() {
    return {
      enabledSwitch: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColor: null,
      enabledStore: Boolean
    };
  },
  methods: {
    setEnabled: function() {
      if (this.enabledStore != this.enabledSwitch) {
        let self = this;
        let url = `${this.$store.state.apiUrl}/notificationConfig/${this.currentType}/setEnabled`;
        axios({
          url: url,
          method: "POST",
          data: qs.stringify({
            name: this.messageKey,
            enabled: this.enabledSwitch
          }),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        })
          .then(function(response) {
            if (response.data.error == "no_error") {
              self.snackbarEnableSuccessful();
            } else {
              self.snackbarEnableFailed();
              console.log(response.data.error);
            }
          })
          .catch(function(error) {
            self.snackbarEnableFailed();
            console.log(error);
          });
      }
    },
    snackbarEnableSuccessful: function() {
      this.snackbarMessage = this.enabledSwitch
        ? "Successfully enabled message"
        : "Successfully disabled message";
      this.snackbarColor = "success";
      this.snackbarShow = true;
      this.enabledStore = this.enabledStore ? false : true;
    },
    snackbarEnableFailed: function() {
      this.snackbarMessage = this.enabledSwitch
        ? "Error enabling message"
        : "Error disabling message";
      this.snackbarColor = "error";
      this.snackbarShow = true;
      this.enabledSwitch = this.enabledSwitch ? false : true;
    }
  },
  mounted: function() {
    this.enabledStore = this.enabled;
    this.enabledSwitch = this.enabledStore;
  }
};
</script>